export default __webpack_public_path__ + "static/media/Dolby_01-copy.48bfa116.png";